export default {
    environment: 'debug',     //debug or online
    api: {
        url: 'https://api.shengmingshuo.com',//正式
        // url: 'http://api.shopdev.shengmingshuo.com', //测试地址
        websocket: 'ws://112.74.78.80:9589'
    },
    chat: {
        title: '生命说客服系统'
    }
}


// WEBPACK FOOTER //
// ./.config.js